import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import './App.css';
import Navbar from './components/navbar';
import Textbox from './components/textbox';
import Cards from './components/cards';
import Textbox2 from './components/textbox2';
import Footer from './components/footer';
import Profile from './pages/profile';




const ConditionalComponents = () => {
  const location = useLocation();
  const { pathname } = location;


  if (pathname === '/Profile' || pathname === '/Contact') {
    return null;
    
  }

  return (
    <>
      <Textbox />
      <Cards />
    </>
  );
};

const ConditionalTextbox = () => {
  const location = useLocation();
  const { pathname } = location;


  if (pathname === '/Contact') {
    return (
    <Textbox2/>
     );
  }
};


function App() {
  
  return (
    <Router>
      <div className="App">
        <Navbar />
        <Routes>
          <Route path="/Profile" element={<Profile />} />
        </Routes>
      <ConditionalComponents />
       <ConditionalTextbox />
        <Footer />
      </div>
    </Router>
  );
}

export default App;
